jQuery(document).ready(function($){
	// Utility nav login box open and close
	$(document).on( 'click', '#utility_login_toggle', function() {
		$('#utility_login_box').slideToggle();
	});
	$(document).on( 'click', '#utility_login_box_close', function() {
		$('#utility_login_box').slideToggle();
	});

	// active states for hamburger icon
	$(document).on( 'click', '.hamburger.animate', function() {
		$(this).toggleClass('active');
	});	

	// Mobile navigation open and close
	$(document).on( 'click', '#mobilenav_toggle', function() {
		$('#mobile_nav').slideToggle();
		$('body').toggleClass('noScroll');
	});	 

	// Mobile login box open and close
	$(document).on( 'click', '#mobile_login_toggle', function() {
		$('#mobile_login_box').slideToggle();
		$('body').toggleClass('noScroll');
	});
	$(document).on( 'click', '#mobile_login_box_close', function() {
		$('#mobile_login_box').slideToggle();
		$('body').toggleClass('noScroll');
	});

	$(document).on( 'click', '.scheduledClosuresToggle', function() {
		$(this).siblings('.closuresList').slideToggle();
		$(this).children('.chevron-up-icon').toggleClass('active');
		$(this).slideUp();
	});

	function mobileNavHeight() {
		// Mobile navigation height
		setTimeout(function () {
			var $alertHeights = 0;
			var $topbarHeight = $('#top-bar-menu').outerHeight();
			var $windowHeight = $(window).height();
			$('.alert_banner').each(function(num, elem) {
				var $height = 0;
				if ($(elem).is(':visible')) {
					$height = $(elem).outerHeight();
				}
				$alertHeights = $alertHeights+$height;
			});
			var $totalHeight = $windowHeight - ($alertHeights+$topbarHeight);
			$('#mobile_nav').css('height', $totalHeight);
		}, 1000);
	}
	mobileNavHeight();

	// Locations views
	$(document).on( 'click', '#locations_grid_view', function() {
		$('#locations_map_view').removeClass('active');
		$(this).addClass('active');
		$('#locations_grid_layout').slideDown();
		$('#locations_map_layout').slideUp();
	});

	$(document).on( 'click', '#locations_map_view', function() {
		$('#locations_grid_view').removeClass('active');
		$(this).addClass('active');
		$('#locations_grid_layout').slideUp();
		$('#locations_map_layout').slideDown();
	});

	// Help form
	$(document).on( 'click', '#help_form_fields_toggle', function() {
		// $('#help_form_fields').slideToggle();
		// $(this).children('.chevron-up-icon').toggleClass('active');
		$('#help_form_fields_toggle .toggle_text .placeholder').addClass('hide');
		$('#help_form_fields_toggle .toggle_text .otherHelp').removeClass('hide');
		$('#help_form_fields_toggle .toggle_text .otherHelp').focus();
	});
	$("input[name='help']").change(function(){
		var userInputhelp = document.getElementsByName('help');
		for (var i = 0, length = userInputhelp.length; i < length; i++) {
			if (userInputhelp[i].checked) {
				// document.getElementById('help_form_fields_toggle').innerHTML = userInputhelp[i].value;
				if (userInputhelp[i].value == 'other') {
					$('#help_form_fields_toggle .toggle_text .otherHelp').removeClass('hide');
					$('#help_form_fields_toggle .toggle_text .otherHelp').focus();
				} else {
					$('#help_form_fields_toggle .toggle_text').html(userInputhelp[i].value);
				}
				break;
			}
		}
		// $('#help_form_fields').slideToggle();
		// $('#help_form_fields_toggle .chevron-up-icon').toggleClass('active');
		return false;
	});

	// Locations form
	$(document).on( 'click', '#locations_search_fields_toggle', function() {
		$('#locations_search_fields').slideToggle();
		$(this).children('.chevron-up-icon').toggleClass('active');
	});
	$("input[name='location_type']").change(function(){
		var userInputhelp = document.getElementsByName('location_type');
		for (var i = 0, length = userInputhelp.length; i < length; i++) {
			if (userInputhelp[i].checked) {
				// document.getElementById('help_form_fields_toggle').innerHTML = userInputhelp[i].value;
				$('#locations_search_fields_toggle .toggle_text').html(userInputhelp[i].value);
				break;
			}
		}
		$('#locations_search_fields').slideToggle();
		$('#locations_search_fields_toggle .chevron-up-icon').toggleClass('active');
		return false;
	});


	//Setting height of product card content
	// $intro_height = $(".product_card .card_inner .content").height();
	// $(".product_card .card_inner .content").css('height','120px');

	$('.related_product_card').each(function(num, elem) {
		elem = $(elem);
		let $intro_height = $(this).find('.intro').height();
		let $title_height = $(this).find('.title').height();
		let $content_height = `${$intro_height+$title_height+64}px`
		$(this).find('.content').css('height',$content_height);
	});
	function setCardHeight() {
		$('.set_height').each(function(num, elem) {
			elem = $(elem);
			let $intro_height = $(this).find('.intro').height();
			let $title_height = $(this).find('.title').height();
			let $content_height = `${$intro_height+$title_height+64}px`
			$(this).find('.content').css('height',$content_height);
		});
	}
	setCardHeight();

	// Alert Banner
	$('.alert_banner').each(function(num, elem) {
		let $elem = $(elem);
		let $alertID = $(this).data('alert');
		if (JSON.parse(localStorage.getItem(`${$alertID}`)) === null) {
			setTimeout(function () {
				$elem.slideDown();
			}, 500);
		} else if (typeof (JSON.parse(localStorage.getItem(`${$alertID}`))) === 'boolean') {
			if (!JSON.parse(localStorage.getItem(`${$alertID}`))) {
				$elem.slideUp();
			}
		}
		let $alertClose = $(this).find('.alertClose');
		$alertClose.click(function() {
			$elem.slideUp();
			localStorage.setItem(`${$alertID}`, 'true');
			mobileNavHeight();
		});
		$elem.change(function(){
			mobileNavHeight();
		});
	});

	$('.large_promo_wrapper').each(function(num, elem) {
		let $elem = $(elem);
		let $prev = $elem.prev();
		if ($prev.get(0).hasAttribute('style')) {
			let attr = $prev.attr('style');
			if (attr.includes('background-color')) {
				let bgColor = $prev.get(0).style.backgroundColor;
				$elem.css({'backgroundColor':bgColor});
			}
		}
	});

	$(window).on('resize', function(){
		mobileNavHeight();
		setCardHeight();
	});

	if ($('#emergencyModal').length) {
		$('#emergencyModal').foundation('open');
	}

    function setupSwitch(switchInput) {
        const labels = document.querySelectorAll(".switch-label");
        const apyColumns = document.querySelectorAll('[data-column="apy"]');
        const dividendRateColumns = document.querySelectorAll('[data-column="dividend"]');

        function toggleSwitch() {
			updateSwitch();
        }

        function updateSwitch() {
			labels.forEach(label => label.classList.toggle('active'));
			apyColumns.forEach(column => {
				column.classList.toggle('hide-for-small-only');
			})
			dividendRateColumns.forEach(column => {
				column.classList.toggle('hide-for-small-only');
			})
			switchInput.checked = !switchInput.checked;
        }

        labels.forEach(label => label.addEventListener("click", toggleSwitch));

        switchInput.addEventListener("keydown", (event) => {
            if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                toggleSwitch();
            }
        });

        //updateSwitch();
    }

	document.querySelectorAll(".toggle-switch").forEach(setupSwitch);
});